export const localesMap: Record<string, { shortName: string; name: string }> = {
  ru: { shortName: 'Ру', name: 'Русский' },
  uz: { shortName: 'Ўз', name: 'Ўзбекча' },
  oz: { shortName: "O'z", name: "O'zbekcha" },
};

export type Locale = keyof typeof localesMap;

export const locales = Object.keys(localesMap) as Locale[];

export const defaultLocale: Locale = 'oz';
